import { routes } from '@/app/routing/router'
import { AuthPageView } from './view'

const currentRoute = routes.auth

const AuthPageRoute = {
  route: currentRoute,
  view: AuthPageView,
}

export { currentRoute, AuthPageRoute }
